export default __webpack_public_path__ + "static/media/icon.91729f3a.svg";